export default function UiRouterTypeCustomDate($urlMatcherFactoryProvider) {
    'ngInject';
    // Adding custom date param, the problem with date is that ui-router encodes
    // date as a string, and slashes are coded twice and become '%252F', which sometimes
    // causes unwanted behavior of the ui router. Here we set the rules for encoding ourselves.
    function valToString(val) {
        return val !== null ? val.toString() : val;
    }

    function regexpMatches(val) {
        return this.pattern.test(val);
    }

    $urlMatcherFactoryProvider.type('customDate', {
        encode: valToString,
        decode: valToString,
        is: regexpMatches,
        pattern: /[^/]*/,
    });
}



// WEBPACK FOOTER //
// ./src/app/configs/ui-router-type-custom-date.js